import {
  GeoJSONFeature
} from 'maplibre-gl';

import * as CommonSelectors from './utils/common_selectors';
import doubleClickZoom from './utils/double_click_zoom';
import DrawLine from './utils/draw_line_string';

import {calculateSnapTolerance} from './utils/CalculateSnapTolerance';
import * as Constants from './utils/constants';
import {deegrees2meters, meters2degrees, lineAngle} from "../../utils";
import { drawModes, drawState, Source } from '../../Types';

const PaintMode:drawModes = <drawModes>{ ...DrawLine };

PaintMode.onSetup = function (options:any) {
  // this.map._paintMode = PaintMode;
  PaintMode.state = <drawState>{};
  PaintMode._this = <drawModes>{};

  // try {
  //   document.getElementsByClassName('geobox-gl-rotate-icon')[0].checked = false;
  //   document.getElementsByClassName('geobox-gl-hole-icon')[0].checked = false;
  //   document.getElementsByClassName('geobox-gl-split-icon')[0].checked = false;
  // } catch (error) {
  // }

  const line = this.newFeature({
    type: Constants.geojsonTypes.FEATURE,
    properties: {},
    geometry: {
      type: Constants.geojsonTypes.LINE_STRING,
      coordinates: [[]],
    },
  });


  this.addFeature(line);

  const selectedFeatures = this.getSelected();
  this.clearSelectedFeatures();
  doubleClickZoom.disable(this);
  this.map.dragPan.disable();  

  const state:drawState = <drawState>{
    map: this.map,
    line,
    currentVertexPosition: 0,
    selectedFeatures,
    direction: 'forward', // expected by DrawLineString
  };

  state.options = <drawState["options"]>this._ctx.options;

  const optionsChangedCallBAck = (options:any) => {
    state.options = options;
  };

  state.optionsChangedCallBAck = optionsChangedCallBAck;

  this.map.on('draw.snap.options_changed', optionsChangedCallBAck);

  this.snapMarkerSource = (<Source>this.map.getSource('geobox-gl-snap-marker'))._data;

  PaintMode.state = state;

  PaintMode._this = this;

  return state;
};



PaintMode.onDrag = PaintMode.onTouchMove = function (state:drawState, e:any){

  this.map.getCanvasContainer().style.cursor = "crosshair";

  const { lng, lat } = e.lngLat;

  let minDistance = state.options.snapTolerance;
  let desiredCoord = [0,0];

  if (state.options.snap) {
    [<any>minDistance, <any>desiredCoord] = calculateSnapTolerance(this.map, e, state);
  }

  if (state.options.snap && minDistance && state.options.snapTolerance && minDistance < state.options.snapTolerance) {
    state.snappedLng = desiredCoord[0];
    state.snappedLat = desiredCoord[1];
  } else {
    state.snappedLng = lng;
    state.snappedLat = lat;
    if (this.map.getLayer('geobox-gl-snap-marker')) {
      this.map.setPaintProperty('geobox-gl-snap-marker', 'circle-color', 'rgba(255, 255, 255, 1)');
      this.map.setPaintProperty('geobox-gl-snap-marker', 'circle-stroke-color', 'rgba(255, 0, 0, 1)');
    }
  }

  this.snapMarkerSource.features = [{
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [state.snappedLng, state.snappedLat]
    }
  }];

  (<Source>this.map.getSource('geobox-gl-snap-marker')).setData(this.snapMarkerSource);
  
  state.line.updateCoordinate(state.currentVertexPosition, state.snappedLng, state.snappedLat);

  state.currentVertexPosition++;

  state.line.updateCoordinate(state.currentVertexPosition, state.snappedLng, state.snappedLat);
}

PaintMode.onTap = function (state:any, e:any) {
  if (CommonSelectors.isVertex(e)) return this.clickOnVertex(state, e);
  this.onMouseMove(state, e);
  this.onClick(state, e);
}

PaintMode.onClick = function (state:any) {
  const lng = state.snappedLng;
  const lat = state.snappedLat;

  if (state.currentVertexPosition > 0) {

    // try {
    //   document.getElementById('geobox-gl-geometry-length-parameter-checkbox').checked = false;
    //   this.map._draw.options.limitDrawLength = false;
    //   document.getElementById('geobox-gl-geometry-bearing-parameter-checkbox').checked = false;
    //   this.map._draw.options.limitDrawBearing = false;
    //   document.getElementById('geobox-gl-geometry-angle-parameter-checkbox').checked = false;
    //   this.map._draw.options.limitDrawAngle = false;
    // } catch (error) {
      
    // }

    const lastVertex = state.line.coordinates[state.currentVertexPosition - 1];

    state.lastVertex = lastVertex;

    if (lastVertex[0] === lng && lastVertex[1] === lat) {
      PaintMode.state = <drawState>{};
      PaintMode._this = <drawModes>{};
      return this.changeMode(Constants.modes.DIRECT_SELECT, {
        featureId: state.line.id,
      });
    }
  }

  state.line.updateCoordinate(state.currentVertexPosition, lng, lat);

  state.currentVertexPosition++;

  state.line.updateCoordinate(state.currentVertexPosition, lng, lat);
};

PaintMode.onMouseMove = function (state:drawState, e:any) {
  this.map.getCanvasContainer().style.cursor = "crosshair";
  const { lng, lat } = e.lngLat;

  let minDistance = state.options.snapTolerance;
  let desiredCoord = [0,0];

  if (state.options.snap) {
    [<any>minDistance, <any>desiredCoord] = calculateSnapTolerance(this.map, e, state);
  }

  if (state.options.snap && minDistance && state.options.snapTolerance && minDistance < state.options.snapTolerance) {
    state.snappedLng = desiredCoord[0];
    state.snappedLat = desiredCoord[1];
  } else {
    state.snappedLng = lng;
    state.snappedLat = lat;
  }

  // if (state.options.limitDrawLength && state.options.limitDrawBearing){

    
  //   if (state.line.coordinates.length >= 2){
  //     var limitDrawLength = document.getElementById('geobox-gl-geometry-length-parameter');
  //     var limitDrawBearing = document.getElementById('geobox-gl-geometry-bearing-parameter');

  //     if (limitDrawLength){
  //       const pXY0 = state.line.getCoordinate(`${state.currentVertexPosition-1}`);
  //       const pXY0_3857 = deegrees2meters(pXY0);
  //       const pXY2_3857 = [];
  //       if (Number(limitDrawBearing.value) === 90){
  //         pXY2_3857[0] = pXY0_3857[0];
  //         pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value);
  //       }else if (Number(limitDrawBearing.value) === 270){
  //         pXY2_3857[0] = pXY0_3857[0];
  //         pXY2_3857[1] = pXY0_3857[1]- Number(limitDrawLength.value);
  //       }else {
  //         pXY2_3857[0] = pXY0_3857[0]+ Number(limitDrawLength.value)*Math.cos(Number(limitDrawBearing.value)*Math.PI/180);
  //         pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value)*Math.sin(Number(limitDrawBearing.value)*Math.PI/180);
  //       }

  //       const pXY2 = meters2degrees(pXY2_3857);
        
  //       state.snappedLng = pXY2[0];
  //       state.snappedLat = pXY2[1];
  //     }
  //   }
  // }else if (state.options.limitDrawLength && state.options.limitDrawAngle){

  //   if (state.line.coordinates.length >= 3){
  //     var limitDrawLength = document.getElementById('geobox-gl-geometry-length-parameter');
  //     var limitDrawAngle = document.getElementById('geobox-gl-geometry-angle-parameter');

  //     if (limitDrawLength){
  //       const pXY0 = state.line.getCoordinate(`${state.currentVertexPosition-2}`);
  //       const pXY0_3857 = deegrees2meters(pXY0);
  //       const pXY1 = state.line.getCoordinate(`${state.currentVertexPosition-1}`);
  //       const pXY1_3857 = deegrees2meters(pXY1);

  //       // const pXY2_3857 = deegrees2meters([lng, lat]);

  //       const pXY3_3857 = [];

  //       var angle = lineAngle(pXY0_3857, pXY1_3857);

  //       var newAngle = 180 - (Number(limitDrawAngle.value) - angle );

  //       if (newAngle === 90){
  //         pXY3_3857[0] = pXY1_3857[0];
  //         pXY3_3857[1] = pXY1_3857[1]+ Number(limitDrawLength.value);
  //       }else if (newAngle === 270){
  //         pXY3_3857[0] = pXY1_3857[0];
  //         pXY3_3857[1] = pXY1_3857[1]- Number(limitDrawLength.value);
  //       }else {
  //         pXY3_3857[0] = pXY1_3857[0]+ Number(limitDrawLength.value)*Math.cos(newAngle*Math.PI/180);
  //         pXY3_3857[1] = pXY1_3857[1]+ Number(limitDrawLength.value)*Math.sin(newAngle*Math.PI/180);
  //       }

  //       const pXY3 = meters2degrees(pXY3_3857);
      
  //       state.snappedLng = pXY3[0];
  //       state.snappedLat = pXY3[1];
  //     }
  //   }
  // }else {
  //   if (state.options.limitDrawLength) {
  //     if (state.line.coordinates.length >= 2){
  //       var limitDrawLength = document.getElementById('geobox-gl-geometry-length-parameter');
  //       if (limitDrawLength){
  //         const pXY0 = state.line.getCoordinate(`${state.currentVertexPosition-1}`);
  //         const pXY0_3857 = deegrees2meters(pXY0);
  //         const pXY1_3857 = deegrees2meters([lng, lat]);
  //         const pXY2_3857 = [];
         
  //         var dy = pXY1_3857[1]-pXY0_3857[1];
  //         var dx = pXY1_3857[0]-pXY0_3857[0];
  
  //         if (dx >= 0 ){
  //           pXY2_3857[0] = pXY0_3857[0]+ Number(limitDrawLength.value)*Math.cos(Math.atan(dy/dx));
  //           pXY2_3857[1] = pXY0_3857[1]+ Number(limitDrawLength.value)*Math.sin(Math.atan(dy/dx));
  //         }else {
  //           pXY2_3857[0] = pXY0_3857[0]- Number(limitDrawLength.value)*Math.cos(Math.atan(dy/dx));
  //           pXY2_3857[1] = pXY0_3857[1]- Number(limitDrawLength.value)*Math.sin(Math.atan(dy/dx));
  //         }
  
  //         const pXY2 = meters2degrees(pXY2_3857);
        
  //         state.snappedLng = pXY2[0];
  //         state.snappedLat = pXY2[1];
  //       }
  //     }
  //   }
  
  //   if (state.options.limitDrawBearing) {
  //     if (state.line.coordinates.length >= 2){
  //       var limitDrawBearing = document.getElementById('geobox-gl-geometry-bearing-parameter');
  //       if (limitDrawBearing){
  //         const pXY0 = state.line.getCoordinate(`${state.currentVertexPosition-1}`);
  //         const pXY0_3857 = deegrees2meters(pXY0);
  //         const pXY1_3857 = deegrees2meters([lng, lat]);
  //         const pXY2_3857 = [];

  //         if (Number(limitDrawBearing.value) !== 90 && Number(limitDrawBearing.value) !== 270){
  //           pXY2_3857[0] = pXY1_3857[0];
  //           pXY2_3857[1] = pXY0_3857[1]+ Math.tan(Number(limitDrawBearing.value)*Math.PI/180)*(pXY2_3857[0]-pXY0_3857[0]);
  //         }else {
  //           pXY2_3857[0] = pXY0_3857[0];
  //           pXY2_3857[1] = pXY1_3857[1];
  //         }
         
  //         const pXY2 = meters2degrees(pXY2_3857);
        
  //         state.snappedLng = pXY2[0];
  //         state.snappedLat = pXY2[1];
  //       }
  //     }
  //   }
  //   if (state.options.limitDrawAngle) {
  //     if (state.line.coordinates.length >= 3){
  //       var limitDrawAngle = document.getElementById('geobox-gl-geometry-angle-parameter');
  //       if (limitDrawAngle){
        
  //         const pXY0 = state.line.getCoordinate(`${state.currentVertexPosition-2}`);
  //         const pXY0_3857 = deegrees2meters(pXY0);
  //         const pXY1 = state.line.getCoordinate(`${state.currentVertexPosition-1}`);
  //         const pXY1_3857 = deegrees2meters(pXY1);

  //         const pXY2_3857 = deegrees2meters([lng, lat]);

  //         const pXY3_3857 = [];

  //         var angle = lineAngle(pXY0_3857, pXY1_3857);

        
  //         var newAngle = 180 - (Number(limitDrawAngle.value) - angle );

  //         if (newAngle !== 90 && newAngle !== 270){
  //           pXY3_3857[0] = pXY2_3857[0];
  //           pXY3_3857[1] = pXY1_3857[1]+ Math.tan(newAngle*Math.PI/180)*(pXY3_3857[0]-pXY1_3857[0]);
  //         }else {
  //           pXY3_3857[0] = pXY0_3857[0];
  //           pXY3_3857[1] = pXY2_3857[1];
  //         }
          
  //         const pXY3 = meters2degrees(pXY3_3857);
        
  //         state.snappedLng = pXY3[0];
  //         state.snappedLat = pXY3[1];
  //       }
  //     }
  //   }
  // }

  this.snapMarkerSource.features = [{
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [state.snappedLng, state.snappedLat]
    }
  }];

  (<Source>this.map.getSource('geobox-gl-snap-marker')).setData(this.snapMarkerSource);

  state.line.updateCoordinate(state.currentVertexPosition, state.snappedLng, state.snappedLat);
  
  if (
    state.lastVertex
    && state.lastVertex[0] === lng
    && state.lastVertex[1] === lat
  ) {
    this.updateUIClasses({ mouse: Constants.cursors.POINTER });
  } else {
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
  }
};

PaintMode.toDisplayFeatures = function (state:drawState, geojson:GeoJSONFeature, display:any) {
  DrawLine.toDisplayFeatures(state, geojson, display);
};

PaintMode.onStop = function (state:drawState) {
  PaintMode.state = <drawState>{};
  PaintMode._this = <drawModes>{};

  this.snapMarkerSource.features = [{
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": []
    }
  }];

  (<Source>this.map.getSource('geobox-gl-snap-marker')).setData(this.snapMarkerSource);

  this.map.getCanvasContainer().style.cursor = "grab";
  
  DrawLine.onStop.call(this, state);

  // this.map._updateCoordinateTable();
  // document.getElementById("geobox-gl-draw-free-hand").classList.remove("active");
};

PaintMode.onKeyUp = function(state:drawState, e:any) {
  if (e.key === 'Enter') {
    this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
  } else if (e.key === 'Escape') {
    // this.deleteFeature([state.line.id], { silent: true });
    // this.changeMode(Constants.modes.SIMPLE_SELECT);


    // if (state.currentVertexPosition > 2) {
      //remove the last point
      state.currentVertexPosition--;
      state.line.removeCoordinate(`${state.currentVertexPosition}`);
      // console.log(state.currentVertexPosition,'  ', state.snappedLng,'  ', state.snappedLat)

      state.line.updateCoordinate(state.currentVertexPosition, state.snappedLng, state.snappedLat);
   
    // } 
    // else {
    //   this.deleteFeature([state.line.id], { silent: true });
    //   this.changeMode(Constants.modes.SIMPLE_SELECT);
    // }
  }
};


PaintMode.removeLastVertex = function(state:drawState, _this:drawModes) {
  try {
    // if (state.currentVertexPosition > 2) {

      state.currentVertexPosition--;
      state.line.removeCoordinate(`${state.currentVertexPosition}`);
   
      state.line.updateCoordinate(state.currentVertexPosition, state.snappedLng, state.snappedLat);
  
      state.line.updateCoordinate(state.currentVertexPosition, 35, 53);

      _this.onMouseMove(state,{lngLat:{lng:35, lat:53}})

  
  
      // _this.map._update()
  
      // _this.map.getSource('mapbox-gl-draw-hot').setData(_this.map.getStyle().sources['mapbox-gl-draw-hot']['data'])
  
      // _this.map.getSource('mapbox-gl-draw-cold').setData(_this.map.getStyle().sources['mapbox-gl-draw-cold']['data'])
  
    // }
  } catch (error) {}
   
};

PaintMode.finishDraw = function(state:drawState, _this:drawModes) {
  try {
    _this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.line.id] });
  } catch (error) { 
  }
};

PaintMode.cancelDraw = function(state:drawState, _this:drawModes) {
  try {
    _this.deleteFeature([state.line.id], { silent: true });
    _this.changeMode(Constants.modes.SIMPLE_SELECT);
  } catch (error) {
  }
};

export default PaintMode;
